import { Box } from '@mui/material';

export const WhattaDraw = () => {
  return <Box>hello world</Box>;
};
